'use client';

import { useLanguage } from '@/contexts/LanguageContext';
import { Inter } from 'next/font/google';

const inter = Inter({ subsets: ['latin'] });

export default function AppWrapper({ children }: { children: React.ReactNode }) {
  const { language } = useLanguage();
  
  return (
    <div 
      dir={language === 'ar' ? 'rtl' : 'ltr'} 
      className={`${inter.className} ${language === 'ar' ? 'font-arabic' : ''} antialiased`}
    >
      {children}
    </div>
  );
}